import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import { useAccount } from '../assets/js/ContextProviders/AccountContext';
import { handleSubmit } from '../apis/dataService';
import DefaultImg from '../Images/Products/Default.png';

export default function Cards(props) {
    const [selectedproduct, setselectedproduct] = useState({});
    const { AccountObj, Account } = useAccount();
    const [shouldSubmit, setShouldSubmit] = useState(false);

    // QUANTITY PLUS MINUS LOGIC:
    const [quantity, setquantity] = useState(1);
    function minusquantity() {
        setquantity(Math.max(0, quantity - 1));
    }
    function plusquantity() {
        setquantity(quantity + 1);
    }

    // DYNAMICALLY IMPORT IMAGES OF CARDS:
    const [img, setimg] = useState(null);
    useEffect(() => {
        // Dynamically import the image using the variable
        import(`../Images/Products/${props.imgname}.png`)
            .then((image) => setimg(image.default))
            .catch((error) => console.error('Error loading image:', error));
    }, [props.imgname, props.category]); // Add props.imgname and props.category to the dependency array

    // GET QUANTITY AND PRODUCT FROM USER:
    function AddtoCart() {
        const parentquantityDIV = document.getElementById(`${props.index}`);
        const viewcartBtn = document.getElementById(`viewcart${props.index}`);
        const addtocartBtn = document.getElementById(`addtocart${props.index}`);
        const loginboom = document.getElementById(`login-signup-boom`)
        if (parentquantityDIV.style.display === 'flex') {
            setselectedproduct(props);
            setselectedproduct((prevUser) => ({ ...prevUser, ['Quantity']: quantity }));
            if (Account()) {
                setShouldSubmit(true);
                viewcartBtn.style.display = 'flex';
                parentquantityDIV.style.display = 'none';
                addtocartBtn.style.display = 'none';
            } else {
                loginboom.style.display = 'flex'
            }
        } else {
            parentquantityDIV.style.display = 'flex';
        }
    }

    // SEND DATA TO SERVER:
    useEffect(() => {
        if (shouldSubmit) {
            handleSubmit({
                api: 'cart',
                userAcc: AccountObj(),
                mergedData: selectedproduct
            });
            setShouldSubmit(false);
        }
    }, [shouldSubmit, selectedproduct, AccountObj]);

    return (
        <>
            <div className="card">
                <div className="card-image">
                    <img src={img ? img : DefaultImg} className="product--image" alt="" />
                </div>
                <div className="card-content">
                    <h2>{props.name}</h2>
                    <p className="price">Price: {props.price} -/Rs</p>
                    {/* <p>{props.description}</p> */}
                    <div className='card-content-div'>
                        <div className="quatity-of-product" id={props.index}>
                            <button className="minus" onClick={minusquantity}>
                                <i className="fas fa-minus"></i>
                            </button>
                            <div className="quantity">
                                {quantity}
                            </div>
                            <button className="plus" onClick={plusquantity}>
                                <i className="fas fa-plus"></i>
                            </button>
                        </div>
                        <button onClick={AddtoCart} className='Add-to-card' id={`addtocart${props.index}`}>
                            Add to Cart
                        </button>
                        <Link to='/cart'>
                            <div className="view-cart Add-to-card" id={`viewcart${props.index}`}>
                                View Cart
                            </div>
                        </Link>
                    </div>
                </div>
            </div>

        </>
    );
}
